import { z } from 'zod';
/**
 * Call Block v1 Configuration Validator
 * Validates configuration for blocking a call in pre-call workflows
 */
export const Call_Block_1_ConfigValidator = z.object({
    reason: z.string().optional()
});
//# sourceMappingURL=call-block-1.js.map